import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';
import { INewUserPasscodeRequest, INewUserPasscodeSuccess } from '../models/new-user-passcode.model';

export const loadNewUserPasscodes = createAction('[NewUserPasscode] Load NewUserPasscodes', props<{ request: INewUserPasscodeRequest }>());

export const loadNewUserPasscodesSuccess = createAction(
  '[NewUserPasscode] Load NewUserPasscodes Success',
  props<{ response: INewUserPasscodeSuccess }>()
);

export const loadNewUserPasscodesFailure = createAction(
  '[NewUserPasscode] Load NewUserPasscodes Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);


export const newUserPasscode = createAction('[NewUserPasscode] Load NewUserPasscodes', props<{ request: INewUserPasscodeRequest }>());

export const newUserPasscodeSuccess = createAction(
  '[NewUserPasscode] Load NewUserPasscodes Success',
  props<{ response: INewUserPasscodeSuccess }>()
);

export const newUserPasscodeFailure = createAction(
  '[NewUserPasscode] Load NewUserPasscodes Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);